import {writable} from 'svelte/store';

//using dummy value until we get the formtting right in order to spare the api
// export const apiResults = writable(JSON.stringify({
//     'url': 'http://www.twitter.de',
//     'bytes': 897575,
//     'green': false,
//     'id': -1,
//     'statistics': {
//         'adjustedBytes': 677669,
//         'energy': 0.0011391868302598595,
//         'co2': {
//             'grid': {
//                 'grams': 0.5411137443734333,
//                 'litres': 0.3009674646205036
//             },
//             'renewable': {
//                 'grams': 0.49040480202576364,
//                 'litres': 0.27276315088672975
//             }
//         }
//     },
//     'cleanerThan': 0.35
// }));

export const apiResults = writable();

export const hideMobileMenu = writable();